
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { globalStore } from "@/store/store";
import { CSSSelector } from "@/types/selectors";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";

@Component({
  components: { Dropdown, NiceButton, TextInput }
})
export default class AddClass extends Vue {
  @Prop()
  existingClasses!: string[];

  newClassName: string | null = null;

  get allClasses() {
    return globalStore.cssSelectors.filter(s => s.type === "class");
  }

  get newClassNameAlreadyExists() {
    return !!this.allClasses.find(
      c => c.name === this.newClassName || c.name === `.${this.newClassName}`
    );
  }

  get items() {
    const bag = [];

    if (!this.newClassNameAlreadyExists && this.newClassName) {
      const newClass = this.newClassName.replace(".", ""); // Strip duplicate dot in the UI
      bag.push({
        text: `Create <em>.${newClass}</em>`,
        value: this.newClassName
      });
    }

    if (this.autocompleteClassNames.length > 0) {
      bag.push({
        header: "Existing Classes"
      });

      bag.push(...this.autocompleteClassNames);
    }

    return bag;
  }

  addClass(className: string) {
    this.$emit("input", className);
    this.newClassName = null;
  }

  get autocompleteClassNames() {
    const includesSearchString = (cssClass: CSSSelector) => {
      if (!this.newClassName) return true;
      return cssClass.name.includes(this.newClassName);
    };

    const removeClassesAlreadyPresent = (cssClass: CSSSelector) =>
      !this.existingClasses.includes(cssClass.name);

    return this.allClasses
      .filter(includesSearchString)
      .filter(removeClassesAlreadyPresent)
      .map(cssClass => {
        return {
          text: cssClass.name,
          value: cssClass.name
        };
      });
  }
}
